/**
 * Shoppable Reels Grid + Full-Screen Viewer
 * Native Shopify build — uses Shopify's /products/{handle}.js and /cart/add.js
 * No external app dependency.
 */

window.initReelsGrid = function (gridId, reels) {
  var grid = document.getElementById(gridId);
  if (!grid || !reels || !reels.length) return;

  var viewer = document.getElementById('reels-viewer');
  var track = document.getElementById('reels-viewer-track');
  var closeBtn = document.getElementById('reels-viewer-close');
  var currentIndex = 0;
  var built = false;

  function buildViewer() {
    if (built) return;
    built = true;

    reels.forEach(function (reel, i) {
      var slide = document.createElement('div');
      slide.className = 'reels-viewer-slide';
      slide.dataset.index = i;

      var video = document.createElement('video');
      video.className = 'reels-viewer-video';
      video.src = reel.videoUrl;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.muted = false;
      slide.appendChild(video);

      if (reel.caption) {
        var cap = document.createElement('div');
        cap.className = 'reels-viewer-caption';
        cap.textContent = reel.caption;
        slide.appendChild(cap);
      }

      var cardWrap = document.createElement('div');
      cardWrap.className = 'reels-viewer-product-card';
      cardWrap.innerHTML = '<div class="reels-loading">Loading product…</div>';
      slide.appendChild(cardWrap);

      track.appendChild(slide);

      if (reel.productHandle) {
        fetch('/products/' + reel.productHandle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (product) {
            renderProductCard(cardWrap, product);
          })
          .catch(function () {
            cardWrap.innerHTML = '';
          });
      } else {
        cardWrap.innerHTML = '';
      }
    });
  }

  function renderProductCard(container, product) {
    var variant = product.variants[0];
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var priceFormatted = formatMoney(variant.price);
    var compareFormatted = variant.compare_at_price > variant.price
      ? formatMoney(variant.compare_at_price)
      : null;

    container.innerHTML =
      '<img class="reels-product-thumb" src="' + image + '" alt="' + product.title + '">' +
      '<div class="reels-product-info">' +
        '<div class="reels-product-title">' + product.title + '</div>' +
        '<div class="reels-product-price">' +
          '<span class="reels-price-now">' + priceFormatted + '</span>' +
          (compareFormatted ? '<span class="reels-price-was">' + compareFormatted + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<button class="reels-add-to-cart" data-variant-id="' + variant.id + '">Add to Cart</button>';

    var btn = container.querySelector('.reels-add-to-cart');
    btn.addEventListener('click', function () {
      addToCart(variant.id, btn);
    });

    container.querySelector('.reels-product-thumb').addEventListener('click', function () {
      window.location.href = '/products/' + product.handle;
    });
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function addToCart(variantId, btn) {
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      });
  }

  function openViewer(index) {
    buildViewer();
    currentIndex = index;
    viewer.classList.add('is-open');
    viewer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    goToSlide(index, false);
  }

  function closeViewer() {
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    track.querySelectorAll('video').forEach(function (v) { v.pause(); });
  }

  function goToSlide(index, smooth) {
    if (index < 0 || index >= reels.length) return;
    currentIndex = index;
    var slide = track.children[index];
    track.scrollTo({ top: slide.offsetTop, behavior: smooth === false ? 'auto' : 'smooth' });

    track.querySelectorAll('video').forEach(function (v, i) {
      if (i === index) {
        v.currentTime = 0;
        v.play().catch(function () {});
      } else {
        v.pause();
      }
    });
  }

  // Grid click -> open viewer
  grid.querySelectorAll('.reels-grid-item').forEach(function (item) {
    item.addEventListener('click', function () {
      var idx = parseInt(item.dataset.reelIndex, 10);
      openViewer(idx);
    });
  });

  // Plus icon click -> small product popup (image + name), instead of opening the full viewer
  grid.querySelectorAll('.reels-grid-tag').forEach(function (tag) {
    tag.addEventListener('click', function (e) {
      e.stopPropagation(); // don't trigger the grid-item click above
      var item = tag.closest('.reels-grid-item');
      toggleProductPopup(item);
    });
  });

  // Close any open popup when clicking elsewhere on the page
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.reels-product-popup') && !e.target.closest('.reels-grid-tag')) {
      document.querySelectorAll('.reels-product-popup.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
    }
  });

  function toggleProductPopup(item) {
    var existing = item.querySelector('.reels-product-popup');

    // close any other open popups first
    document.querySelectorAll('.reels-product-popup.is-open').forEach(function (p) {
      if (p !== existing) p.classList.remove('is-open');
    });

    if (existing) {
      existing.classList.toggle('is-open');
      return;
    }

    var handle = item.dataset.productHandle;
    if (!handle) return;

    var popup = document.createElement('div');
    popup.className = 'reels-product-popup';
    popup.innerHTML = '<div class="reels-loading">Loading…</div>';
    item.appendChild(popup);
    requestAnimationFrame(function () { popup.classList.add('is-open'); });

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var image = product.featured_image || (product.images && product.images[0]) || '';
        popup.innerHTML =
          '<img class="reels-popup-thumb" src="' + image + '" alt="' + product.title + '">' +
          '<span class="reels-popup-title">' + product.title + '</span>';
        popup.addEventListener('click', function (e) {
          e.stopPropagation();
          window.location.href = '/products/' + product.handle;
        });
      })
      .catch(function () {
        popup.innerHTML = '';
      });
  }

  closeBtn.addEventListener('click', closeViewer);

  // Swipe support
  var touchStartY = 0;
  track.addEventListener('touchstart', function (e) {
    touchStartY = e.touches[0].clientY;
  });
  track.addEventListener('touchend', function (e) {
    var diff = touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(diff) < 50) return;
    if (diff > 0) goToSlide(currentIndex + 1);
    else goToSlide(currentIndex - 1);
  });

  // Keyboard support (desktop)
  document.addEventListener('keydown', function (e) {
    if (!viewer.classList.contains('is-open')) return;
    if (e.key === 'ArrowDown') goToSlide(currentIndex + 1);
    if (e.key === 'ArrowUp') goToSlide(currentIndex - 1);
    if (e.key === 'Escape') closeViewer();
  });
};
